module.exports = __webpack_public_path__ + "img/aghk-car-disabled.399a96cf.svg";